__turbopack_context__.v({
  "closeButton": "notification-drawer-module__djAQrW__closeButton",
  "drawer": "notification-drawer-module__djAQrW__drawer",
  "drawer-in": "notification-drawer-module__djAQrW__drawer-in",
  "empty": "notification-drawer-module__djAQrW__empty",
  "footer": "notification-drawer-module__djAQrW__footer",
  "item": "notification-drawer-module__djAQrW__item",
  "itemBody": "notification-drawer-module__djAQrW__itemBody",
  "itemCaption": "notification-drawer-module__djAQrW__itemCaption",
  "itemIcon": "notification-drawer-module__djAQrW__itemIcon",
  "itemSubject": "notification-drawer-module__djAQrW__itemSubject",
  "items": "notification-drawer-module__djAQrW__items",
  "markAllButton": "notification-drawer-module__djAQrW__markAllButton",
  "overlay": "notification-drawer-module__djAQrW__overlay",
  "title": "notification-drawer-module__djAQrW__title",
  "titleRow": "notification-drawer-module__djAQrW__titleRow",
  "unreadCount": "notification-drawer-module__djAQrW__unreadCount",
  "unreadRow": "notification-drawer-module__djAQrW__unreadRow",
  "viewAllButton": "notification-drawer-module__djAQrW__viewAllButton",
});
